<template>
  <sc-table
    :data="tableData"
    :loading="loading"
    default-sort="@timestamp"
    default-sort-direction="desc">

    <template slot-scope="props">
      <sc-table-column
        field="request_uri"
        label="Chamada"
        sortable>
        {{ props.row.request_uri }}
      </sc-table-column>

      <sc-table-column
        field="response_status"
        label="Status"
        width="10"
        sortable>
        <sc-tag :type="tagType(props.row.response_status)">
          {{ props.row.response_status }}
        </sc-tag>
      </sc-table-column>

      <sc-table-column
        field="request_method"
        label="Tipo"
        width="60"
        sortable>
        {{ props.row.request_method }}
      </sc-table-column>

      <sc-table-column
        field="@timestamp"
        label="Data"
        width="130"
        sortable>
        {{ props.row['@timestamp'] | date('DD/MM/YYYY HH:mm:ss') }}
      </sc-table-column>

      <sc-table-column
        field="ip"
        label="IP"
        width="100"
        sortable>
        {{ props.row.remoteaddr }}
      </sc-table-column>

      <sc-table-column
        field="platform"
        label="Plataforma"
        sortable>
        {{ props.row.platform }}
      </sc-table-column>

      <sc-table-column
        field="plugin"
        label="Plugin"
        sortable>
        {{ props.row.plugin }}
      </sc-table-column>

      <sc-table-column
        field="type"
        label="Type"
        width="200"
        sortable>
        {{ props.row.type }}
      </sc-table-column>

      <sc-table-column
        field="actions"
        label="Visualizar">
        <sc-field
          position="is-centered"
          :addons="hasAddons(props)">
          <p
            class="control"
            v-if="props.row.request_body">
            <sc-button
              theme="primary"
              text="Request"
              @click="openRequestFilesGallery(props.index)" />
          </p>

          <p
            class="control has-text-centered"
            v-if="props.row.response_body || props.row.response_xml">
            <sc-button
              theme="info"
              text="Response"
              v-if="props.row.response_body || props.row.response_xml"
              @click="openResponseFilesGallery(props.index)" />
          </p>
        </sc-field>
      </sc-table-column>
    </template>

    <template slot="empty">
      <sc-table-empty />
    </template>
  </sc-table>
</template>
<script>
  import {
    ScField,
    ScButton,
    ScIcon,
    ScTag,
    ScTable,
    ScTableColumn,
    ScTableEmpty,
    ScFilesGallery,
  } from '@intelipost-js/secure-components';

  import { createNamespacedHelpers } from 'vuex';

  const { mapState, mapGetters } = createNamespacedHelpers('analytic/logsApi');

  export default {
    name: 'sc-logs-api-table',
    props: {
      tableData: {
        type: Array,
        required: true,
      },
      type: {
        type: String,
        default: null,
      },
    },
    computed: {
      ...mapState([
        'loading',
      ]),
      ...mapGetters([
        'logsRequest',
        'errorLogsRequest',
        'logsResponse',
        'errorLogsResponse',
      ]),
    },
    methods: {
      openRequestFilesGallery(fileIndex = 0) {
        const logs = (this.type && this.type === 'error') ? 'errorLogsRequest' : 'logsRequest';

        if (this[logs].length > 0) {
          ScFilesGallery.open(this.$instance, {
            selected: this[logs][fileIndex],
            files: this[logs],
          });
        }
      },
      openResponseFilesGallery(fileIndex = 0) {
        const logs = (this.type && this.type === 'error') ? 'errorLogsResponse' : 'logsResponse';

        if (this[logs].length > 0) {
          ScFilesGallery.open(this.$instance, {
            selected: this[logs][fileIndex],
            files: this[logs],
          });
        }
      },
      tagType(statusCode) {
        return String(statusCode).match(/(2.*)|(3.*)/) ? 'is-primary' : 'is-danger';
      },
      hasAddons(props = {}) {
        return !!(props.row.response_body && (props.row.request_body || props.row.response_xml));
      },
    },
    components: {
      ScField,
      ScButton,
      ScIcon,
      ScTag,
      ScTable,
      ScTableColumn,
      ScTableEmpty,
      ScFilesGallery,
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-analytic/features/logs/pages/api/components/sc-logs-api-table/ScLogsApiTable.vue